import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalService } from './modal.service';
import { Button } from '../button/button';
import {
  InfoIconComponent,
  CheckIconComponent,
  WarningIconComponent,
  CloseIconComponent,
  DeleteIconComponent,
  OutlinedCloseIconComponent,
} from '../icons';

@Component({
  selector: 'lib-modal',
  imports: [
    CommonModule,
    Button,
    DeleteIconComponent,
    CloseIconComponent,
    InfoIconComponent,
    WarningIconComponent,
    CheckIconComponent,
    OutlinedCloseIconComponent,
  ],
  templateUrl: './modal.html',
  styleUrl: './modal.css',
})
export class Modal {
  modalService = inject(ModalService);
  isOpen = this.modalService.isOpen;
  config = this.modalService.config;

  readonly defaultModalClass = 'px-6 py-8 sm:px-[6.625rem] sm:py-[5.125rem]';

  close() {
    this.modalService.close();
  }
}
